<template>
  <b-card title="مدیریت آگهی‌ها">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="نوع"
                  label-for="Kind"
                >
                  <v-select
                    v-model="filterOptions.Kind"
                    :options="kindOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          show-empty
          empty-text="آگهی‌ای یافت نشد"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item.Id)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Image)="data">
            <b-avatar
              :src="data.value"
              size="40"
              rounded
            />
          </template>

          <template #cell(Title)="data">
            <div class="d-flex align-items-center">
              <span>{{ data.value }}</span>
              <b-badge
                v-if="data.item.IsBumped"
                variant="light-primary"
                class="ml-50"
              >نردبان</b-badge>
            </div>
          </template>

          <template #cell(Kind)="data">
            <b-badge :variant="kindVariant(data.value)">
              {{ kindText(data.value) }}
            </b-badge>
          </template>

          <template #cell(CityTitle)="data">
            <span>{{ data.value || '—' }}</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">
              {{ statusText(data.value) }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            <span class="text-nowrap">{{ data.value | date('date') }}</span>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="cursor-pointer"
                @click="openDetails(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- مدال جزئیات -->
    <b-modal
      v-if="showModal"
      v-model="showModal"
      centered
      hide-footer
      title="جزئیات آگهی"
      :no-close-on-backdrop="true"
      size="lg"
    >
      <div
        v-if="detailLoading"
        class="text-center my-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div v-else-if="detail">
        <b-row>
          <b-col
            md="12"
            class="mb-1 d-flex flex-wrap align-items-center"
          >
            <h5 class="mb-0 mr-1">
              {{ detail.Title }}
            </h5>
            <b-badge
              :variant="statusVariant(detail.Status)"
              class="mr-50"
            >{{ statusText(detail.Status) }}</b-badge>
            <b-badge
              :variant="kindVariant(detail.Kind)"
              class="mr-50"
            >{{ kindText(detail.Kind) }}</b-badge>
            <b-badge
              v-if="detail.IsBumped"
              variant="light-primary"
              class="mr-50"
            >نردبان‌شده</b-badge>
          </b-col>

          <b-col
            v-if="detail.Images && detail.Images.length"
            md="12"
            class="mb-1"
          >
            <div class="doc-gallery">
              <a
                v-for="img in detail.Images"
                :key="img.Id"
                :href="img.Image"
                target="_blank"
                class="doc-thumb"
              >
                <img :src="img.Image">
              </a>
            </div>
          </b-col>

          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">قیمت</small>
            <div class="font-weight-bold">
              {{ priceText(detail) }}
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">محل آگهی</small>
            <div class="font-weight-bold">
              {{ cityText(detail) }}
            </div>
          </b-col>

          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">آگهی‌دهنده</small>
            <div class="font-weight-bold">
              {{ ((detail.Owner && detail.Owner.Name) || '') + ' ' + ((detail.Owner && detail.Owner.Family) || '') }}
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">موبایل</small>
            <div class="font-weight-bold">
              {{ detail.Owner ? detail.Owner.Mobile : '—' }}
            </div>
          </b-col>

          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">تاریخ ثبت</small>
            <div class="font-weight-bold">
              {{ detail.CreatedAt | date('date-time') }}
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">بازدید</small>
            <div class="font-weight-bold">
              {{ detail.Visit }}
            </div>
          </b-col>

          <b-col
            v-if="detail.Categories && detail.Categories.length"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دسته‌بندی کالا</small>
            <div class="mt-25">
              <b-badge
                v-for="c in detail.Categories"
                :key="c.ProductCategoryId"
                variant="light-success"
                class="mr-50 mb-50"
              >{{ c.Title }}</b-badge>
            </div>
          </b-col>

          <b-col
            v-if="detail.ServiceAreas && detail.ServiceAreas.length"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">حوزه‌های خدمات</small>
            <div class="mt-25">
              <b-badge
                v-for="a in detail.ServiceAreas"
                :key="a"
                variant="light-info"
                class="mr-50 mb-50"
              >{{ serviceAreaText(a) }}</b-badge>
            </div>
          </b-col>

          <b-col
            v-if="detail.Description"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">توضیحات</small>
            <div class="ad-description">
              {{ detail.Description }}
            </div>
          </b-col>

          <b-col
            v-if="detail.Status === 1 && detail.RejectReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل رد</small>
            <div class="text-danger">
              {{ detail.RejectReason }}
            </div>
          </b-col>
        </b-row>

        <hr>

        <div class="d-flex flex-wrap justify-content-end">
          <b-button
            variant="outline-primary"
            class="mr-1 mb-1"
            @click="openEdit"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-25"
            />
            ویرایش
          </b-button>
          <b-button
            v-if="detail.Status !== 1"
            variant="outline-danger"
            class="mr-1 mb-1"
            @click="openReject"
          >
            رد آگهی
          </b-button>
          <b-button
            v-if="detail.Status !== 2"
            variant="success"
            class="mb-1"
            @click="accept"
          >
            تأیید آگهی
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- مدال رد با دلیل -->
    <b-modal
      v-if="showReject"
      v-model="showReject"
      centered
      ok-title="ثبت رد"
      cancel-title="انصراف"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      title="رد آگهی"
      :no-close-on-backdrop="true"
      @ok="reject"
    >
      <b-form-group
        label="دلیل رد (به آگهی‌دهنده نمایش داده می‌شود)"
        label-for="RejectReason"
      >
        <b-form-textarea
          v-model="rejectReason"
          rows="3"
          no-resize
          placeholder="مثلاً تصاویر نامرتبط است…"
        />
      </b-form-group>
    </b-modal>

    <!-- مدال ویرایش آگهی توسط ادمین -->
    <b-modal
      v-if="showForm"
      v-model="showForm"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="ویرایش آگهی"
      :no-close-on-backdrop="true"
      size="lg"
      @ok.prevent="save"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="عنوان"
            label-for="Title"
          >
            <b-form-input
              v-model="form.Title"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="نوع"
            label-for="Kind"
          >
            <v-select
              v-model="form.Kind"
              :options="kindOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="قیمت توافقی"
            label-for="IsNegotiable"
          >
            <v-select
              v-model="form.IsNegotiable"
              :options="yesNoOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="!form.IsNegotiable && form.Kind !== 2"
          md="4"
        >
          <b-form-group
            label="قیمت (تومان)"
            label-for="Price"
          >
            <b-form-input
              v-model.number="form.Price"
              type="number"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <template v-if="!form.IsNegotiable && form.Kind === 2">
          <b-col md="4">
            <b-form-group
              label="قیمت از (تومان)"
              label-for="PriceFrom"
            >
              <b-form-input
                v-model.number="form.PriceFrom"
                type="number"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="قیمت تا (تومان)"
              label-for="PriceTo"
            >
              <b-form-input
                v-model.number="form.PriceTo"
                type="number"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
        </template>

        <b-col md="6">
          <b-form-group
            label="استان"
            label-for="StateId"
          >
            <z-state
              v-model="form.StateId"
              :clearable="true"
              @input="onStateChange"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="شهر"
            label-for="CityId"
          >
            <v-select
              v-model="form.CityId"
              dir="rtl"
              label="Title"
              :reduce="x => x.Id"
              :options="cityOptions"
              :loading="cityLoading"
              :disabled="!form.StateId"
              :placeholder="form.StateId ? 'انتخاب شهر' : 'ابتدا استان را انتخاب کنید'"
            >
              <span slot="no-options">موردی یافت نشد</span>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="دسته‌بندی کالا"
            label-for="ProductCategoryId"
          >
            <z-product-category
              v-model="form.ProductCategoryId"
              :multiple="true"
              :clearable="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="form.Kind === 2"
          md="6"
        >
          <b-form-group
            label="حوزه‌های خدمات"
            label-for="ServiceArea"
          >
            <v-select
              v-model="form.ServiceArea"
              :options="serviceAreaOptions"
              dir="rtl"
              label="text"
              multiple
              :reduce="x => x.value"
            >
              <span slot="no-options">موردی یافت نشد</span>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="عکس‌ها"
            label-for="Images"
          >
            <input
              ref="refImages"
              type="file"
              class="d-none"
              accept="image/*"
              multiple
              @change="imagesRenderer($event)"
            >
            <div class="doc-edit-grid">
              <div
                v-for="img in existingImages"
                :key="`e-${img.Id}`"
                class="doc-edit-item"
              >
                <img :src="img.Image">
                <span
                  class="doc-del"
                  @click="removeExistingImage(img.Id)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <div
                v-for="(src, i) in newImagePreviews"
                :key="`n-${i}`"
                class="doc-edit-item new"
              >
                <img :src="src">
                <span
                  class="doc-del"
                  @click="removeNewImage(i)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <div
                class="doc-edit-add"
                @click="$refs.refImages.click()"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="22"
                />
                <span>افزودن</span>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="form.Description"
              rows="4"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZState from '@/tools/state.vue'
import ZProductCategory from '@/tools/productcategory.vue'

export default {
  name: 'Advertisement',
  components: { ZState, ZProductCategory },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Mobile: null,
        Kind: null,
        Status: null,
        Page: 1,
        PerPage: 10,
      },
      yesNoOptions: [
        { text: 'بله', value: true },
        { text: 'خیر', value: false },
      ],
      kindOptions: [
        { text: 'خرید کالا', value: 0 },
        { text: 'فروش کالا', value: 1 },
        { text: 'خدمات', value: 2 },
      ],
      statusOptions: [
        { text: 'در انتظار تأیید', value: 0 },
        { text: 'ردشده', value: 1 },
        { text: 'تأییدشده', value: 2 },
      ],
      serviceAreaOptions: [
        { text: 'گمرک و ترخیص کالا', value: 1 },
        { text: 'حمل و نقل و لجستیک', value: 2 },
        { text: 'پرداخت و امور مالی ارزی', value: 3 },
        { text: 'قراردادها و مسائل حقوقی', value: 4 },
        { text: 'بازاریابی و فروش (صادرات)', value: 5 },
        { text: 'منبع‌یابی و خرید خارجی (واردات)', value: 6 },
        { text: 'بیمه و مدیریت ریسک', value: 7 },
        { text: 'بازرسی کالا', value: 8 },
        { text: 'استاندارد و خدمات آزمایشگاهی', value: 9 },
      ],
      showModal: false,
      showReject: false,
      showForm: false,
      detailLoading: false,
      detail: null,
      rejectReason: null,
      form: {},
      cityOptions: [],
      cityLoading: false,
      existingImages: [],
      removeImageId: [],
      newImages: [],
      newImagePreviews: [],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Image', label: 'عکس', thClass: 'col-width-50' },
        { key: 'Title', label: 'عنوان' },
        { key: 'Kind', label: 'نوع' },
        { key: 'CityTitle', label: 'شهر' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'Visit', label: 'بازدید', thClass: 'col-width-50' },
        { key: 'CreatedAt', label: 'تاریخ' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    kindText(value) {
      return ['خرید کالا', 'فروش کالا', 'خدمات'][value] || '—'
    },
    kindVariant(value) {
      return ['light-success', 'light-warning', 'light-info'][value] || 'light-secondary'
    },
    statusText(value) {
      return ['در انتظار تأیید', 'ردشده', 'تأییدشده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-danger', 'light-success'][value] || 'light-secondary'
    },
    serviceAreaText(value) {
      const item = this.serviceAreaOptions.find(x => x.value === value)
      return item ? item.text : '—'
    },
    cityText(detail) {
      if (!detail || !detail.City) return '—'
      return [detail.City.StateTitle, detail.City.Title].filter(Boolean).join('، ')
    },
    priceText(detail) {
      if (!detail) return '—'
      if (detail.IsNegotiable) return 'توافقی'
      if (detail.Kind === 2) {
        const from = detail.PriceFrom
        const to = detail.PriceTo
        if (from && to) return `${this.money(from)} تا ${this.money(to)} تومان`
        if (from) return `از ${this.money(from)} تومان`
        if (to) return `تا ${this.money(to)} تومان`
        return '—'
      }
      return detail.Price ? `${this.money(detail.Price)} تومان` : '—'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.advertisement.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(id) {
      this.showModal = true
      this.detail = null
      this.detailLoading = true
      this.$http.post(this.$api.advertisement.get, { Id: id })
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    accept() {
      this.$http.post(this.$api.advertisement.moderate, { Id: this.detail.Id, Accept: true })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    openReject() {
      this.rejectReason = this.detail.RejectReason || null
      this.showReject = true
    },
    reject() {
      this.$http.post(this.$api.advertisement.moderate, { Id: this.detail.Id, Accept: false, RejectReason: this.rejectReason })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    openEdit() {
      const d = this.detail
      this.form = {
        Id: d.Id,
        Title: d.Title,
        Description: d.Description,
        Kind: d.Kind,
        IsNegotiable: d.IsNegotiable,
        Price: d.Price,
        PriceFrom: d.PriceFrom,
        PriceTo: d.PriceTo,
        StateId: d.City ? d.City.StateId : null,
        CityId: d.City ? d.City.Id : null,
        ProductCategoryId: (d.Categories || []).map(c => c.ProductCategoryId),
        ServiceArea: (d.ServiceAreas || []).slice(),
      }
      this.existingImages = (d.Images || []).slice()
      this.removeImageId = []
      this.newImages = []
      this.newImagePreviews = []
      this.cityOptions = []
      if (this.form.StateId) this.loadCities(this.form.StateId, false)
      this.showModal = false
      this.showForm = true
    },
    loadCities(stateId, reset = true) {
      if (!stateId) {
        this.cityOptions = []
        return
      }
      this.cityLoading = true
      this.$http.post(this.$api.city.getall, { StateId: stateId })
        .then(res => {
          this.cityOptions = res.data
          if (reset) this.form.CityId = null
        })
        .finally(() => {
          this.cityLoading = false
        })
    },
    onStateChange(stateId) {
      this.loadCities(stateId, true)
    },
    imagesRenderer(event) {
      const files = Array.from(event.target.files || [])
      files.forEach(file => {
        if (!file.type.startsWith('image/')) return
        this.newImages.push(file)
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.newImagePreviews.push(reader.result)
        }
      })
      event.target.value = ''
    },
    removeNewImage(index) {
      this.newImages.splice(index, 1)
      this.newImagePreviews.splice(index, 1)
    },
    removeExistingImage(id) {
      this.removeImageId.push(id)
      this.existingImages = this.existingImages.filter(img => img.Id !== id)
    },
    save() {
      const formData = new FormData()

      formData.append('Id', this.form.Id)
      formData.append('Title', this.form.Title || '')
      formData.append('Description', this.form.Description || '')
      formData.append('Kind', this.form.Kind)
      formData.append('IsNegotiable', this.form.IsNegotiable)

      if (!this.form.IsNegotiable) {
        if (this.form.Kind === 2) {
          if (this.form.PriceFrom) formData.append('PriceFrom', this.form.PriceFrom)
          if (this.form.PriceTo) formData.append('PriceTo', this.form.PriceTo)
        } else if (this.form.Price) {
          formData.append('Price', this.form.Price)
        }
      }

      if (this.form.CityId) {
        formData.append('CityId', this.form.CityId)
      }

      const categories = this.form.ProductCategoryId || []
      categories.forEach(id => {
        formData.append('ProductCategoryId', id)
      })

      if (this.form.Kind === 2) {
        const areas = this.form.ServiceArea || []
        areas.forEach(area => {
          formData.append('ServiceArea', area)
        })
      }

      this.removeImageId.forEach(id => {
        formData.append('RemoveImageId', id)
      })

      this.newImages.forEach(file => {
        formData.append('Images', file)
      })

      this.$http.post(this.$api.advertisement.update, formData)
        .then(() => {
          this.showForm = false
          this.update()
        })
    },
  },
}
</script>

<style scoped>
.doc-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.doc-thumb {
  display: block;
  width: 96px;
  height: 96px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ad-description {
  white-space: pre-line;
}

.doc-edit-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-edit-item {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-edit-item.new {
  border-color: #7367f0;
}

.doc-edit-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-del {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
}

.doc-edit-add {
  width: 92px;
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1.5px dashed #c3ccd6;
  border-radius: 0.357rem;
  color: #6e6b7b;
  cursor: pointer;
  font-size: 0.8rem;
}

.doc-edit-add:hover {
  border-color: #7367f0;
  color: #7367f0;
}
</style>
